var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.298 15.707a.96.96 0 0 0 .457.258c.176.043.35.043.522 0 .172-.044.324-.129.456-.254L8 9.433l6.272 6.277a.98.98 0 0 0 .712.29.972.972 0 0 0 .723-.294c.192-.2.289-.44.29-.724a.969.969 0 0 0-.287-.712L9.437 7.994l6.272-6.266A.988.988 0 0 0 16 1.011a.947.947 0 0 0-.294-.719 1.005 1.005 0 0 0-.723-.29.961.961 0 0 0-.712.287L7.999 6.564 1.733.288a1.003 1.003 0 0 0-.456-.254A1.108 1.108 0 0 0 .755.029.892.892 0 0 0 .298.29a1.028 1.028 0 0 0-.257.462 1.06 1.06 0 0 0 0 .522.951.951 0 0 0 .254.452L6.56 7.994.295 14.27a1.043 1.043 0 0 0-.263.98.926.926 0 0 0 .266.456z",
    fill: "#7F9292",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearIcon);
export default __webpack_public_path__ + "static/media/clear-icon.c0aad26e.svg";
export { ForwardRef as ReactComponent };